<div class="module-cards-container text-center">
	<h2 class="ready-set-header">We’re More Than a License</h2>

	<p class="reduce-risk-content">
		Rely on us to help you get setup, implement best practices, modernize
		your <br class="d-none d-sm-block" />
		compliance business processes, load your data, and provide ongoing
		patching, <br class="d-none d-sm-block" />
		support, and hosting options. <br /><br />
		Explore support options for every budget with turn-key solutions
		available to <br class="d-none d-sm-block" />
		simplify implementation for every customer.
	</p>

	<div class="row module-cards-grid">
		<div class="col-lg-4 mb-5">
			<div class="regscale-works-card-bottom">
				<img
					width="120px"
					height="120px"
					src="../../assets/img/professional-services.svg"
					alt=""
				/>
			</div>
			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="
						regscale-works-card-inner
						module-cards-linear-gradient1
					"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="
									regscale-works-card
									module-cards-linear-gradient1
								"
								>Professional Services
							</strong>
							<p class="mt-2">
								Obtain best practices on using RegScale through
								our <br class="d-none d-sm-block" />
								world-class DevSecOps engineers who can assist
								<br class="d-none d-sm-block" />
								with installation, data loading, and platform
								<br class="d-none d-sm-block" />
								configuration.

								<br /><br />

								You can buy these services in a short duration
								(by <br class="d-none d-sm-block" />
								Agile Sprint) or we have anual options for 1/2
								time <br class="d-none d-sm-block" />
								and full-time engineering support.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="col-lg-4 mb-5">
			<div class="regscale-works-card-bottom">
				<img width="120px" src="../../assets/img/hosting.svg" alt="" />
			</div>
			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="
						regscale-works-card-inner
						module-cards-linear-gradient4
					"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="
									regscale-works-card
									module-cards-linear-gradient4
								"
								>Hosting
							</strong>
							<p class="mt-2">
								Leave the software support to us. Our RegScale
								<br class="d-none d-sm-block" />

								Engineers will deploy and support RegScale in
								your
								<br class="d-none d-sm-block" />
								environment or ours with negotiated SLAs and
								<br class="d-none d-sm-block" />
								dedicated staffing for customers who don't wish
								to
								<br class="d-none d-sm-block" />
								support software themselves.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="col-lg-4 mb-5">
			<div class="regscale-works-card-bottom">
				<img width="120px" src="../../assets/img/support.svg" alt="" />
			</div>

			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="
						regscale-works-card-inner
						module-cards-linear-gradient2
					"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="
									regscale-works-card
									module-cards-linear-gradient2
								"
								>Support
							</strong>
							<p class="mt-2">
								Our support options are flexible, including 9 -
								5 <br class="d-none d-sm-block" />
								standard business hours, 24x7x365 support,
								and<br class="d-none d-sm-block" />
								opportunities for US Citizen only support (or
								even <br class="d-none d-sm-block" />cleared
								personnel to support National Security
								<br class="d-none d-sm-block" />
								environments).
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
